import {
  productFamilyIdFormat,
  productFamilyOptionIdFormat,
  productFamilyOptionValueIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const OptionSelectionSchema_ = z.object({
  optionId: productFamilyOptionIdFormat.schema,
  valueId: productFamilyOptionValueIdFormat.schema,
});

export const OptionSelectionSchema: z.ZodType<OptionSelection> =
  OptionSelectionSchema_;
export interface OptionSelection
  extends z.infer<typeof OptionSelectionSchema_> {}

export const addProductVariant = {
  name: "addProductVariant" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    optionSelections: z.array(OptionSelectionSchema_),
    title: z.string().optional(),
    sku: z.string().optional(),
    price: z.number().optional(),
    currency: z.string().optional(),
  }),
  output: z.object({ productId: productIdFormat.schema }),
};
